import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Divider } from 'antd'
import Screen from '../../Components/Screen'

import Initializing from './Components/Initializing'
import Breadcrumbs from './Components/Breadcrumbs'
import Header from './Components/Header'
import Tabs from './Components/Tabs'
import Items from './Components/Items'
import Footer from './Components/Footer'
import Sidebar from './Components/Sidebar'
import ApproveRejectModal from './Components/ApproveRejectModal'

const SubcontractorSubOrder = props => {

  const {
    subOrder,
    activeTab,
    componentDidMount,
    componentWillUnmount,
  } = props

  const [modalState, setModalState] = useState({
    visible: false,
    action: null, // 'approve' or 'reject'
  })

  useEffect(() => {
    componentDidMount(props)
    return componentWillUnmount
  }, [])

  const handleApprove = () => {
    setModalState({ visible: true, action: 'approve' })
  }

  const handleReject = () => {
    setModalState({ visible: true, action: 'reject' })
  }

  const handleCloseModal = () => {
    setModalState({ visible: false, action: null })
  }

  const handleSuccess = () => {
    // Refresh the order data
    componentDidMount(props)
  }

  if (!subOrder) return <Initializing />

  return (

    <Screen style={{ marginRight: 280, paddingRight: 30 }}>

      <Breadcrumbs subOrder={subOrder} />

      <Divider />

      <div style={{ fontSize: 16, color: '#999', marginBottom: 8 }}>Sub Order</div>

      <Header 
        subOrder={subOrder}
        onClickApprove={handleApprove}
        onClickReject={handleReject}
      />

      <Tabs />

      {activeTab === 'ITEMS' && <Items />}

      <Footer />

      <Sidebar />

      {modalState.visible && (
        <ApproveRejectModal
          visible={modalState.visible}
          action={modalState.action}
          subOrderId={subOrder.id}
          onClose={handleCloseModal}
          onSuccess={handleSuccess}
        />
      )}

    </Screen>

  )

}

SubcontractorSubOrder.propTypes = {
  subOrder: PropTypes.object,
  activeTab: PropTypes.string.isRequired,
  componentDidMount: PropTypes.func.isRequired,
  componentWillUnmount: PropTypes.func.isRequired,
}

SubcontractorSubOrder.defaultProps = {
  subOrder: null,
}

export default SubcontractorSubOrder
